import React, { FC, useContext } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { TopNav } from 'transfix-ui/components/TopNav'
import { Box } from 'transfix-ui/core'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { UserContext } from 'apps/fleet-planner/context'
import {
  getUserNamesFromEntity,
  getUserSettingsFromUser,
} from 'apps/fleet-planner/utils/getUserData'
import { NavListItem } from 'transfix-ui'
import { DesktopReminder } from '../../components/modals/DesktopReminder'
import { GeneralDateTime } from '../../components/user/GeneralDateTime'
import { IntegrationsCard } from '../../components/user/IntegrationsCard'
import { NotificationsCard } from '../../components/user/NotificationsCard'
import { Profile } from '../../components/user/Profile'
import CarrierProfilesPage from '../carrier-profile/CarrierProfilesPage'

/**
 * Page for all user-toggled settings for Fleet Planner
 */
export const UserSettingsDesktop: FC = () => {
  const { errors, updateUserInfo, updateUserSettings, userData } = useContext(UserContext)
  const { firstName, lastName } = getUserNamesFromEntity(userData)
  const { timeFormat } = getUserSettingsFromUser(userData)
  const isFmsLaneRecommendationsEnabled = useFeatureFlag('fmsLaneRecommendations')
  const isCarrierProfileEnabled = useFeatureFlag('motorCarrierProfileShowFmsTag')

  return (
    <>
      <DesktopReminder message='Your Settings tab is optimized for desktop' />

      <TopNav showMenu={false} title='Settings' />

      <Box display='flex' p={4}>
        <Box flex='0 0 243px'>
          <NavListItem
            text='Your account'
            location='/user/settings/profile'
            size='small'
            data-test='Profile-label'
          />
          {isCarrierProfileEnabled && (
            <NavListItem
              text='Carrier Profiles'
              location='/user/settings/carrier-profiles'
              size='small'
              data-test='carrier-profiles-nav-item'
            />
          )}
          {isFmsLaneRecommendationsEnabled && (
            <NavListItem
              text='Notifications'
              location='/user/settings/notifications'
              size='small'
              data-test='Notifications-label'
            />
          )}
          <NavListItem
            text='ELD Integrations'
            location='/user/settings/integrations'
            size='small'
            data-test='ELD Integrations-label'
          />
          <NavListItem
            text='Time Settings'
            location='/user/settings/general'
            size='small'
            data-test='Time Settings-label'
          />
        </Box>

        <Box flex='1 1 auto'>
          <Switch>
            <Route path='/user/settings/general' exact>
              <GeneralDateTime
                errors={errors}
                timeFormat={timeFormat}
                onSubmit={updateUserSettings}
              />
            </Route>

            <Route path='/user/settings/profile' exact>
              <Profile onSubmit={updateUserInfo} firstName={firstName} lastName={lastName} />
            </Route>

            <Route path='/user/settings/integrations' exact>
              <IntegrationsCard />
            </Route>

            {isFmsLaneRecommendationsEnabled && (
              <Route path='/user/settings/notifications' exact>
                <NotificationsCard />
              </Route>
            )}

            {isCarrierProfileEnabled && (
              <Route path='/user/settings/carrier-profiles' exact>
                <CarrierProfilesPage />
              </Route>
            )}

            {/* default route - navigation */}
            <Route exact path='/user/settings'>
              <Redirect to='/user/settings/profile' />
            </Route>
          </Switch>
        </Box>
      </Box>
    </>
  )
}
